import { render, staticRenderFns } from "./delegation.vue?vue&type=template&id=70119468&scoped=true"
import script from "./delegation.vue?vue&type=script&lang=js"
export * from "./delegation.vue?vue&type=script&lang=js"
import style0 from "./delegation.vue?vue&type=style&index=0&id=70119468&prod&lang=scss&scoped=true"
import style1 from "./delegation.vue?vue&type=style&index=1&id=70119468&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70119468",
  null
  
)

export default component.exports